import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { BatteryRentRestService } from '../battery-rent-rest.service';
import { ExportDataTableService } from '../../../libraries/export/export-data-table.service';
import { AuthenticationService } from '../../../libraries/auth/authentication.service';
import { AclService } from '../../../libraries/auth/acl.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { TebusModal } from '../tebus-modal/tebus-modal.compnent';
import { AddCustomerModalComponent } from '../add-customer-modal/add-customer.compnent';

@Component({
  selector: 'app-battery-rent-list',
  templateUrl: 'battery-rent-list.component.html',
  styleUrls: ['./battery-rent-list.component.scss']
})
export class BatteryRentListComponent extends BaseListBComponent<any> {
  @ViewChild('tebusModal') tebusModal: TebusModal;
  @ViewChild('addCustomerModal') addCustomerModal: AddCustomerModalComponent;

  openTebusModal(data: any) {
    if (this.tebusModal) {
      this.tebusModal.batteryRent = data;
      this.tebusModal.openModal();
    }
  }

  openCustomerModal() {
    if (this.addCustomerModal) {
      this.addCustomerModal.openModal();
    }
  }

  tableColumns = [
    {
      i18nLabel: 'ui.batteryRent.entity.no',
      field: 'no'
    },
    {
      i18nLabel: 'ui.batteryRent.entity.policeNumber',
      field: 'motorcycleNumber',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.chassisNumber',
      field: 'chassisNumber',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.customerName',
      field: 'customerName',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.ktpNumber',
      field: 'nik',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.phoneNumber',
      field: 'customerPhone',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.batteryCode',
      name: 'batteryCode',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.voltageType',
      field: 'voltageType',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.note',
      name: 'alasan',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.duration',
      name: 'duration',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.discountType',
      name: 'discountType',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.startRentDate',
      name: 'firstPurchaseDate',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.expiryRentDate',
      name: 'currentExpiredDate',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.redeemDate',
      name: 'redeemDate',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.dealer',
      name: 'dealer',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.membershipPurchaseHistory',
      name: 'membershipPurchaseHistory',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.status',
      name: 'status',
      field: '',
      sort: true
    },
    {
      i18nLabel: 'ui.batteryRent.entity.detail',
      name: 'detail',
      field: '',
      sort: false
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);
  isLoadingExportExcel: boolean = false;
  isNewSubmissionModalOpen: boolean = false;
  newSubmissionOpened: any = {};
  isReplacementSubmissionModalOpen: boolean = false;
  replacementSubmissionOpened: any = {};
  uploadEndpoint = APP_CONST.API_FILE;
  newBatteryCode: string = '';
  alasan: string = '';
  isMembershipBatteryModalOpen: boolean = false;
  membershipBatteryData: any = {};
  isLoading = false;
  progress: number;
  isTebusModalOpen: boolean = false;
  tebusSubmissionOpened: any = {};

  statuses = [
    {
      text: 'Semua Status',
      value: ''
    },
    {
      text: 'Waiting',
      value: 'waiting'
    },
    {
      text: 'Approved',
      value: 'approved'
    },
    {
      text: 'Rejected',
      value: 'rejected'
    }
  ];

  types = [
    {
      text: 'Semua Tipe Pengajuan',
      value: ''
    },
    {
      text: 'Waiting',
      value: 'waiting'
    },
    {
      text: 'Approved',
      value: 'approved'
    },
    {
      text: 'Rejected',
      value: 'rejected'
    }
  ];

  constructor(
    public _authentication: AuthenticationService,
    private _BatteryRentRest: BatteryRentRestService,
    private _export: ExportDataTableService,
    private _AclService: AclService,
    private el: ElementRef
  ) {
    super();
    this.componentId = 'BatteryRentListComponent';
    this.headerTitle = 'ui.batteryRent.list.title';
    this.qParams.status = '';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        return this._BatteryRentRest.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              d.createdAt = moment(d?.createdAt).format('DD MMMM YYYY HH:mm');
              d.updatedAt = moment(d?.updatedAt).format('DD MMMM YYYY HH:mm');
              d.firstPurchaseDate = d.firstPurchaseDate ? moment(d?.firstPurchaseDate).format('DD MMM YYYY') : '-';
              d.currentExpiredDate = d.currentExpiredDate ? moment(d?.currentExpiredDate).format('DD MMM YYYY') : '-';
              d.redeemDate = d.redeemDate ? moment(d?.redeemDate).format('DD MMM YYYY') : '-';
              return d;
            });

            // Set progress variable based on totalEarlyAdopters
            this.progress = doc?.totalEarlyAdopters || 0; // Default ke 0 kalau undefined
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () => this.page.compHookService?.callMultipleHooks(['BatteryRentListComponent:workflowLoadData'])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }

  openNewSubmissionModal(data) {
    this.isNewSubmissionModalOpen = true;
    this.newSubmissionOpened = data;
  }

  closeNewSubmissionModal() {
    this.isNewSubmissionModalOpen = false;
  }

  openReplacementSubmissionModal(data) {
    this.isReplacementSubmissionModalOpen = true;
    this.replacementSubmissionOpened = data?.data;
  }

  closeReplacementSubmissionModal() {
    this.isReplacementSubmissionModalOpen = false;
    this.membershipBatteryData = [];
  }

  openMembershipBatteryModal(data) {
    this.isMembershipBatteryModalOpen = true;
    this.isLoading = true;

    this._BatteryRentRest.getMembershipHistory(data?.data?.batteryCode).subscribe(
      membershipHistory => {
        // Format the date fields
        const formattedData = membershipHistory.data.map(item => ({
          ...item,
          expired_date: moment(item.expired_date).format('DD MMM YYYY'),
          grace_period_date: moment(item.grace_period_date).format('DD MMM YYYY'),
          purchase_date: moment(item.purchase_date).format('DD MMM YYYY')
        }));

        this.membershipBatteryData = formattedData;
        this.isLoading = false;
      },
      error => {
        console.error('Error fetching membership history:', error);
        this.isLoading = false;
      }
    );
  }

  closeMembershipBatteryModal() {
    this.isMembershipBatteryModalOpen = false;
  }

  onImageFinishUploaded(image, inputName: string) {
    // this.form.patchValue({
    //   approvalDokumen: {
    //     [inputName]: image?.fileUrl,
    //   }
    // });
    console.log('image', image);
  }

  canAccess(pageAction: string) {
    const userAccess: string[] = this._AclService?.exclusivePermissions;
    return userAccess.find(action => action === pageAction);
  }

  getStatusText(status: string): string {
    const statusMap = {
      'Membership Aktif': 'success',
      'Masa Tenggang': 'pending',
      'Membership Tidak Aktif': 'failed'
    };
    return statusMap[status] || '';
  }

  getBatteryRentStatus(batteryRent) {
    let { statusMembership, status } = batteryRent;

    // Replace underscores with spaces and uppercase for comparison
    statusMembership = statusMembership ? statusMembership.replace(/_/g, ' ') : '';
    status = status ? status.replace(/_/g, ' ') : '';

    if (statusMembership === 'ACTIVE' || !statusMembership) {
      return status;
    }

    if (statusMembership === 'INACTIVE') {
      return 'Stop Rent';
    }

    if (['GRACE PERIOD', 'EXPIRED'].includes(statusMembership.toUpperCase())) {
      return statusMembership;
    }

    if (status === 'paid_off') {
      return 'Lunas';
    }

    return status;
  }

  stopRent(id: string): void {
    Swal.fire({
      title: 'Berhenti Sewa Baterai?',
      text: 'Apakah Anda ingin berhenti menyewa baterai ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal'
    }).then(result => {
      if (result.isConfirmed) {
        this._BatteryRentRest.stopRent({ _id: id }).subscribe({
          next: response => {
            Swal.fire('Success', 'Berhenti sewa baterai sukses.', 'success');
            this.callHookDirectly('init');
          },
          error: err => {
            console.error('Error submitting form:', err);
            Swal.fire('Error', err.response?.data?.message, 'error');
          }
        });
      }
    });
  }

  replaceBattery(data): void {
    const payload = {
      _id: data._id,
      newBatteryCode: this.newBatteryCode,
      alasan: this.alasan
    };
    Swal.fire({
      title: 'Penggantian Baterai?',
      text: 'Apakah anda yakin ingin melakukan penggantian baterai?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal'
    }).then(result => {
      if (result.isConfirmed) {
        this._BatteryRentRest.replace(payload).subscribe({
          next: response => {
            Swal.fire('Success', 'Penggantian baterai sukses!', 'success');
            this.callHookDirectly('init');
            this.isReplacementSubmissionModalOpen = false;
          },
          error: err => {
            console.error('Error submitting form:', err);
            Swal.fire('Error', err.response?.data?.message, 'error');
          }
        });
      }
    });
  }

  getStatusColor(status: string) {
    const normalizedStatus = status.toLowerCase().replace(/_/g, ' ');

    if (normalizedStatus === 'renting') return 'primary';
    if (normalizedStatus === 'tebus murah') return 'primary';
    if (normalizedStatus === 'tebus langsung') return 'primary';
    if (normalizedStatus === 'replacement') return 'success';
    if (normalizedStatus === 'paid off') return 'success';
    if (normalizedStatus === 'waiting for pairing') return 'warning';
    if (normalizedStatus === 'waiting for payment') return 'warning';
    if (normalizedStatus === 'stop rent') return 'danger';
    if (normalizedStatus === 'grace period') return 'danger';
    if (normalizedStatus === 'inactive') return 'danger';
    if (normalizedStatus === 'expired') return 'danger';
  }

  formatDate(date: string) {
    return moment(date).format('DD MMMM YYYY HH:mm');
  }

  isTooltipVisible = false;

  toggleTooltip(event: Event): void {
    event.stopPropagation();
    this.isTooltipVisible = !this.isTooltipVisible;
  }

  @HostListener('document:click')
  hideTooltip(): void {
    this.isTooltipVisible = false;
  }

  async onDownloadExcel() {
    this.isLoadingExportExcel = true;
    try {
      const result = await this._BatteryRentRest.findAll({}).toPromise();
      const mapOption = {
        motorcycleNumber: { header: 'No Polisi' },
        chassisNumber: { header: 'No Rangka' },
        customerName: { header: 'Nama Pelanggan' },
        nik: { header: 'No KTP' },
        customerPhone: { header: 'No Telepon' },
        batteryCode: { header: 'Kode Baterai' },
        voltageType: { header: 'Tipe Voltase' },
        alasan: { header: 'Alasan/Catatan' },
        totalMonths: { header: 'Durasi (Bulan)' },
        discountType: { header: 'Tipe Diskon' },
        firstPurchaseDate: { header: 'Tanggal Mulai Sewa' },
        currentExpiredDate: { header: 'Tanggal Berakhir Sewa' },
        redeemDate: { header: 'Tanggal Tebus' },
        dealer: { header: 'Dealer' },
        status: { header: 'Status' },
        statusMembership: { header: 'Status Membership' },
        createdAt: { header: 'Tanggal Dibuat' },
        updatedAt: { header: 'Tanggal Diupdate' }
      };
      const payload = result.data.map(item => ({
        ...item,
        firstPurchaseDate: item.firstPurchaseDate ? moment(item?.firstPurchaseDate).format('DD MMMM YYYY') : '-',
        currentExpiredDate: item.currentExpiredDate ? moment(item?.currentExpiredDate).format('DD MMMM YYYY') : '-',
        redeemDate: item.redeemDate ? moment(item?.redeemDate).format('DD MMMM YYYY') : '-',
        dealer: item.dealerId?.name || '-',
        batteryCode: item.batteryCode || '-',
        alasan: item.alasan || '-',
        totalMonths: item.totalMonths && item.status === 'renting' ? item.totalMonths : '-',
        discountType: item.discountType || '-',
        statusMembership: item.statusMembership || '-',
        createdAt: moment(item?.createdAt).format('DD MMMM YYYY HH:mm'),
        updatedAt: moment(item?.updatedAt).format('DD MMMM YYYY HH:mm')
      }));
      this._export.export({
        extension: 'xlsx',
        fileName: 'Battery Rent',
        records: payload,
        mapOptions: mapOption,
        templateData: null,
        pdfOptions: null
      });
    } catch (error) {
      console.log(error);
      Swal.fire('Error', 'Gagal mengunduh Excel', 'error');
    } finally {
      this.isLoadingExportExcel = false;
    }
  }
}
